import { jsx, jsxs } from "react/jsx-runtime";
function HugeiconsCancel01(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "m18 6l-12 12m0-12l12 12"
		})
	});
}
function HugeiconsArrowDown01(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "m18 9l-6 6l-6-6"
		})
	});
}
function HugeiconsArrowUp01(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "m18 15l-6-6l-6 6"
		})
	});
}
function HugeiconsSearch01(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "m17 17l4 4m-2-10a8 8 0 1 0-16 0a8 8 0 0 0 16 0"
		})
	});
}
function HugeiconsMultiplicationSign(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "m18 6l-6 6m0 0l-6 6m6-6l6 6m-6-6L6 6"
		})
	});
}
function HugeiconsTick02(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "m5 14l3.5 3.5L19 6.5"
		})
	});
}
function HugeiconsCircle(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("circle", {
			cx: 12,
			cy: 12,
			r: 10,
			fill: "none",
			stroke: "currentColor",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	});
}
function HugeiconsArrowRight01(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M9 6s6 4.419 6 6s-6 6-6 6"
		})
	});
}
function HugeiconsSidebarLeft(U) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...U,
		children: /* @__PURE__ */ jsxs("g", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			children: [
				/* @__PURE__ */ jsx("path", { d: "M2 12c0-3.69 0-5.534.814-6.841a4.8 4.8 0 0 1 1.105-1.243C5.08 3 6.72 3 10 3h4c3.28 0 4.919 0 6.081.916c.43.338.804.759 1.105 1.243C22 6.466 22 8.31 22 12s0 5.534-.814 6.841a4.8 4.8 0 0 1-1.105 1.243C18.92 21 17.28 21 14 21h-4c-3.28 0-4.919 0-6.081-.916a4.8 4.8 0 0 1-1.105-1.243C2 17.534 2 15.69 2 12Z" }),
				/* @__PURE__ */ jsx("path", {
					strokeLinejoin: "round",
					d: "M9.5 3v18"
				}),
				/* @__PURE__ */ jsx("path", {
					strokeLinecap: "round",
					strokeLinejoin: "round",
					d: "M5 7h1m-1 3h1"
				})
			]
		})
	});
}
function HugeiconsUnfoldMore(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M18 14s-4.419 5-6 5s-6-5-6-5m12-4s-4.419-5-6-5s-6 5-6 5"
		})
	});
}
function HugeiconsPlusSign(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M12 4v16m8-8H4"
		})
	});
}
function HugeiconsMenu01(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.5,
			d: "M4 5h16M4 12h16M4 19h16"
		})
	});
}
function IconChevronDown(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "m6 9l6 6l6-6"
		})
	});
}
function IconChevronLeft(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "m15 18l-6-6l6-6"
		})
	});
}
function IconChevronRight(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "m9 18l6-6l-6-6"
		})
	});
}
function HugeiconsMinusSign(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M20 12H4"
		})
	});
}
function HugeiconsCalendar02(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M16 2v4M8 2v4m5-2h-2C7.229 4 5.343 4 4.172 5.172S3 8.229 3 12v2c0 3.771 0 5.657 1.172 6.828S7.229 22 11 22h2c3.771 0 5.657 0 6.828-1.172S21 17.771 21 14v-2c0-3.771 0-5.657-1.172-6.828S16.771 4 13 4M3 10h18m-10 4h5m-8 0h.009M13 18H8m8 0h-.009"
		})
	});
}
function HugeiconsArrowLeft01(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M15 6s-6 4.419-6 6s6 6 6 6"
		})
	});
}
function HugeiconsCalendar03(U) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...U,
		children: /* @__PURE__ */ jsxs("g", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1,
			children: [/* @__PURE__ */ jsx("path", {
				strokeWidth: 1.5,
				d: "M16 2v4M8 2v4m5-2h-2C7.229 4 5.343 4 4.172 5.172S3 8.229 3 12v2c0 3.771 0 5.657 1.172 6.828S7.229 22 11 22h2c3.771 0 5.657 0 6.828-1.172S21 17.771 21 14v-2c0-3.771 0-5.657-1.172-6.828S16.771 4 13 4M3 10h18"
			}), /* @__PURE__ */ jsx("path", {
				strokeWidth: 2,
				d: "M11.996 14h.008m-.008 4h.008m3.987-4H16m-8 0h.009M8 18h.009"
			})]
		})
	});
}
function HugeiconsAttachment01(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M5.823 12L4.28 10.456a4.367 4.367 0 1 1 6.177-6.177l9.265 9.265a4.368 4.368 0 0 1-6.177 6.177l-3.474-3.475a2.73 2.73 0 0 1 3.86-3.86l1.93 1.93"
		})
	});
}
function HugeiconsFolder01(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeWidth: 1.5,
			d: "M8 7h8.75c2.107 0 3.16 0 3.917.506a3 3 0 0 1 .827.827C22 9.09 22 10.143 22 12.25c0 3.511 0 5.267-.843 6.528a5 5 0 0 1-1.38 1.38C18.518 21 16.762 21 13.25 21H12c-4.714 0-7.071 0-8.536-1.465C2 18.072 2 15.715 2 11V7.944c0-1.816 0-2.724.38-3.406A3 3 0 0 1 3.538 3.38C4.22 3 5.128 3 6.944 3C8.108 3 8.69 3 9.2 3.191c1.163.436 1.643 1.493 2.168 2.542L12 7"
		})
	});
}
function HugeiconsCamera01(U) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...U,
		children: /* @__PURE__ */ jsxs("g", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1,
			children: [
				/* @__PURE__ */ jsx("path", {
					strokeWidth: 1.5,
					d: "M12.697 3.5h-1.394c-.715 0-1.072 0-1.392.112a2 2 0 0 0-.545.292c-.271.204-.47.501-.866 1.096h0c-.203.305-.502.753-.621.879a2 2 0 0 1-1.106.591c-.17.03-.353.03-.72.03c-.98 0-1.47 0-1.87.113a3 3 0 0 0-2.07 2.07C2 9.083 2 9.573 2 10.553V14.5c0 2.828 0 4.243.879 5.121S5.172 20.5 8 20.5h8c2.829 0 4.243 0 5.122-.879C22 18.743 22 17.328 22 14.5v-3.946c0-.98 0-1.47-.113-1.871a3 3 0 0 0-2.07-2.07c-.4-.113-.89-.113-1.87-.113c-.366 0-.55 0-.72-.03a2 2 0 0 1-1.105-.591c-.12-.126-.419-.574-.622-.879c-.396-.595-.594-.892-.865-1.096a2 2 0 0 0-.545-.292c-.32-.112-.678-.112-1.393-.112"
				}),
				/* @__PURE__ */ jsx("path", {
					strokeWidth: 1.5,
					d: "M16 13a4 4 0 1 1-8 0a4 4 0 0 1 8 0"
				}),
				/* @__PURE__ */ jsx("path", {
					strokeWidth: 2,
					d: "M19 9.5v.01"
				})
			]
		})
	});
}
function LucideMonitor(U) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...U,
		children: /* @__PURE__ */ jsxs("g", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2,
			children: [/* @__PURE__ */ jsx("rect", {
				width: 20,
				height: 14,
				x: 2,
				y: 3,
				rx: 2
			}), /* @__PURE__ */ jsx("path", { d: "M8 21h8m-4-4v4" })]
		})
	});
}
function HugeiconsMoon02(H) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...H,
		children: /* @__PURE__ */ jsx("path", {
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M21.5 14.078A8.557 8.557 0 0 1 9.922 2.5C5.668 3.497 2.5 7.315 2.5 11.873a9.627 9.627 0 0 0 9.627 9.627c4.558 0 8.376-3.168 9.373-7.422"
		})
	});
}
function HugeiconsSun03(U) {
	return /* @__PURE__ */ jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		width: 24,
		height: 24,
		viewBox: "0 0 24 24",
		"data-slot": "icon",
		...U,
		children: /* @__PURE__ */ jsxs("g", {
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 1.5,
			children: [/* @__PURE__ */ jsx("path", { d: "M17 12a5 5 0 1 1-10 0a5 5 0 0 1 10 0Z" }), /* @__PURE__ */ jsx("path", {
				strokeLinecap: "round",
				d: "M12 2v1.5m0 17V22m7.07-2.929l-1.06-1.06M5.99 5.989L4.928 4.93M22 12h-1.5m-17 0H2m17.071-7.071l-1.06 1.06M5.99 18.011l-1.06 1.06"
			})]
		})
	});
}
const MagnifyingGlassIcon = HugeiconsSearch01, XMarkIcon = HugeiconsMultiplicationSign, ChevronUpDownIcon = HugeiconsUnfoldMore, ChevronDownIcon = HugeiconsArrowDown01, PlusIcon = HugeiconsPlusSign, MinusIcon = HugeiconsMinusSign, CalendarDateRangeIcon = HugeiconsCalendar02, CalendarDaysIcon = HugeiconsCalendar03, ChevronLeftIcon = HugeiconsArrowLeft01, ChevronRightIcon = HugeiconsArrowRight01, CheckIcon = HugeiconsTick02, PaperClipIcon = HugeiconsAttachment01, FolderIcon = HugeiconsFolder01, CameraIcon = HugeiconsCamera01, Moon = HugeiconsMoon02, Sun = HugeiconsSun03, Monitor = LucideMonitor;
export { HugeiconsUnfoldMore as A, PlusIcon as B, HugeiconsMoon02 as C, HugeiconsSidebarLeft as D, HugeiconsSearch01 as E, MagnifyingGlassIcon as F, XMarkIcon as H, MinusIcon as I, Monitor as L, IconChevronLeft as M, IconChevronRight as N, HugeiconsSun03 as O, LucideMonitor as P, Moon as R, HugeiconsMinusSign as S, HugeiconsPlusSign as T, Sun as V, HugeiconsCamera01 as _, ChevronDownIcon as a, HugeiconsFolder01 as b, ChevronUpDownIcon as c, HugeiconsArrowLeft01 as d, HugeiconsArrowRight01 as f, HugeiconsCalendar03 as g, HugeiconsCalendar02 as h, CheckIcon as i, IconChevronDown as j, HugeiconsTick02 as k, FolderIcon as l, HugeiconsAttachment01 as m, CalendarDaysIcon as n, ChevronLeftIcon as o, HugeiconsArrowUp01 as p, CameraIcon as r, ChevronRightIcon as s, CalendarDateRangeIcon as t, HugeiconsArrowDown01 as u, HugeiconsCancel01 as v, HugeiconsMultiplicationSign as w, HugeiconsMenu01 as x, HugeiconsCircle as y, PaperClipIcon as z };
